import { Button } from '@outdoor-voices/ui';
import PropTypes from 'prop-types';
import { Five } from './Five';
import { ThreeFour } from './ThreeFour';
import { Two } from './Two';
import { Wrapper } from '../Wrapper';
import css from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CTAs = function CTAs(_ref) {
  var children = _ref.children,
      wrap = _ref.wrap;

  if (!wrap) {
    return children;
  }

  return /*#__PURE__*/_jsx("div", {
    className: css.ctas,
    children: children
  });
};
CTAs.defaultProps = {
  wrap: false
};
CTAs.propTypes = {
  children: PropTypes.node.isRequired,
  wrap: PropTypes.bool
};
export var Category = function Category(_ref2) {
  var blocks = _ref2.blocks,
      title = _ref2.title,
      cta = _ref2.cta,
      ctaExtra = _ref2.ctaExtra,
      displayBackground = _ref2.displayBackground,
      url = _ref2.url,
      urlExtra = _ref2.urlExtra;
  var Child = false;
  var numberOfBlocks = blocks.edges.length;

  if (numberOfBlocks < 2) {
    return false;
  }

  switch (numberOfBlocks) {
    case 1:
    case 2:
      Child = Two;
      break;

    case 3:
    case 4:
      Child = ThreeFour;
      break;

    case 5:
    case 6:
      Child = Five;
      break;
  }

  return /*#__PURE__*/_jsx(Wrapper, {
    wrap: displayBackground,
    children: /*#__PURE__*/_jsxs("section", {
      className: css.root,
      children: [title && /*#__PURE__*/_jsx("h4", {
        className: css.title,
        children: title
      }), /*#__PURE__*/_jsx(Child, {
        blocks: blocks
      }), /*#__PURE__*/_jsxs(CTAs, {
        wrap: !!cta && !!ctaExtra,
        children: [cta && url && /*#__PURE__*/_jsx("div", {
          className: css.cta,
          children: /*#__PURE__*/_jsx(Button, {
            "aria-label": "".concat(cta, " ").concat(cta.indexOf(title) > -1 ? '' : title),
            big: true,
            className: css.ctaButton,
            href: url,
            children: cta
          })
        }), ctaExtra && urlExtra && /*#__PURE__*/_jsx("div", {
          className: css.cta,
          children: /*#__PURE__*/_jsx(Button, {
            "aria-label": "".concat(cta, " ").concat(cta.indexOf(title) > -1 ? '' : title),
            big: true,
            href: urlExtra,
            children: ctaExtra
          })
        })]
      })]
    })
  });
};
Category.propTypes = {
  blocks: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  cta: PropTypes.string,
  ctaExtra: PropTypes.string,
  displayBackground: PropTypes.bool,
  title: PropTypes.string,
  url: PropTypes.string,
  urlExtra: PropTypes.string
};